'use client';
import styled from 'styled-components';

export const StyledList = styled.div`
  box-sizing: border-box;
  display: grid;
  width: ${props => (props.$maxWidth ? '100%' : 'auto')};
  max-width: ${props => props.$maxWidth || 'none'};
  min-height: ${props => props.$minHeight || 'auto'};
  gap: ${props => (props.$gap ? props.theme.spacing(props.$gap) : 0)};
  ${props =>
    props.$backgroundColor &&
    `background-color: ${props.theme.colors.get(props.$backgroundColor)};`}
  ${props => props.$borderRadius && `border-radius: ${props.$borderRadius};`}
  ${props =>
    props.$padding && `padding: ${props.theme.spacing(...props.$padding)};`}
`;

export const ListHeader = styled.h2`
  ${props => props.theme.typography.heading3}
  padding-bottom: ${props => props.theme.spacing(3)};
`;
